import { useEffect, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "../../app/BrandLogo";
import { CreateLink } from "../landing/CreateLink";
import { LandingFooter } from "../landing/LandingFooter";
import { LandingNavigation } from "../landing/LandingNavigation";
import type { BlogPost } from "./posts";
import { getBlogSeo } from "./seo";
import { installBlogSeo } from "./seoDom";
import "../landing/landing.css";
import "./blog.css";

export function BlogLayout({ path, children }: { path: string; children: ReactNode }) {
  useEffect(() => installBlogSeo(getBlogSeo(path)), [path]);

  return <div className="landing blog-page">
    <a className="landing-skip" href="#blog-main">Skip to content</a>
    <LandingNavigation showTestimonials={false} homeSections />
    {children}
    <LandingFooter homeSections />
  </div>;
}

export function BlogBreadcrumbs({ post }: { post?: BlogPost }) {
  return <nav className="blog-breadcrumbs" aria-label="Breadcrumb">
    <ol><li><Link to="/">Home</Link></li><li>{post ? <Link to="/blog">Blog</Link> : <span aria-current="page">Blog</span>}</li>{post && <li><span aria-current="page">{post.title}</span></li>}</ol>
  </nav>;
}

export function BlogCover({ cover }: { cover: BlogPost["cover"] }) {
  return <div className={`blog-cover${cover.statistic ? " blog-cover--statistic" : ""}`}>
    {cover.statistic && <div className="blog-cover__statistic">
      <span className="blog-cover__eyebrow">INK IN NUMBERS</span>
      <strong>{cover.statistic.value}</strong>
      <span>{cover.statistic.label}</span>
    </div>}
    <img src={cover.src} alt={cover.alt} width="640" height="640" />
  </div>;
}

export function BlogCta() {
  return <aside className="blog-cta" aria-label="Create a tattoo stencil">
    <div className="blog-cta__mark"><BrandLogo compact /></div>
    <div className="blog-cta__copy"><p>Your next idea starts here.</p><span>Turn your reference into a stencil you can make your own.</span></div>
    <CreateLink label="Create free stencil" placement="blog" />
  </aside>;
}
